document
  .querySelectorAll(".shopify-section > div")
  .forEach(function (section) {
    const bgColor = window.getComputedStyle(section).backgroundColor;
    const rgb = bgColor.match(/\d+/g);

    if (!rgb) return;

    const [r, g, b] = rgb.map(Number);
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

    section.classList.remove("is-light", "is-dark");

    if (luminance > 186) {
      section.classList.add("is-light");
    } else {
      section.classList.add("is-dark");
    }
  });

(function initFullPageSwiper() {
  /*
   * 기본 애니메이션 설정
   */
  const SPEED = 1000;
  const MIN_SWIPE_SPEED = 450;
  const MAX_SWIPE_SPEED = 1000;

  const EASING = "cubic-bezier(0.22, 1, 0.36, 1)";

  /*
   * 드래그 및 플릭 설정
   */
  const DRAG_THRESHOLD = 0.5;
  const DRAG_START_DISTANCE = 15;
  const FLICK_VELOCITY = 0.55;
  const INPUT_LOCK_TIME = 100;

  let currentTransitionSpeed = SPEED;

  function setPositions(swiperInstance, animated) {
    const H = swiperInstance.height;
    const current = swiperInstance.activeIndex;

    swiperInstance.slides.forEach(function (slide, index) {
      const inner = slide.querySelector(":scope > .slide-inner");

      /*
       * 모든 슬라이드를 같은 위치에 겹쳐놓음
       */
      slide.style.position = "absolute";
      slide.style.top = "0";
      slide.style.left = "0";
      slide.style.width = "100%";
      slide.style.height = "100%";
      slide.style.zIndex = String(index + 1);

      /*
       * 현재 및 이전 슬라이드는 화면에 위치하고
       * 다음 슬라이드는 화면 아래에서 대기
       */
      const slideY = index <= current ? 0 : H;

      if (animated) {
        slide.style.transition =
          "transform " +
          currentTransitionSpeed +
          "ms " +
          EASING;
      } else {
        slide.style.transition = "none";
      }

      slide.style.transform =
        "translate3d(0, " + slideY + "px, 0)";

      if (inner) {
        inner.style.transition = "none";
        inner.style.transform = "translate3d(0, 0, 0)";
      }
    });
  }

  function setup() {
    if (typeof Swiper === "undefined") return;

    const container =
      document.getElementById("fullpage-swiper");

    if (
      !container ||
      container.classList.contains("swiper-initialized")
    ) {
      return;
    }

    const main = document.getElementById("MainContent");
    const footer = document.getElementById("site-footer");

    const swiperWrapper = document.createElement("div");
    swiperWrapper.className = "swiper-wrapper";

    const sections = main
      ? Array.from(
          main.querySelectorAll(":scope > .shopify-section"),
        )
      : [];

    sections.forEach(function (section) {
      const slide = document.createElement("div");
      slide.className = "swiper-slide";

      const inner = document.createElement("div");
      inner.className = "slide-inner";

      inner.appendChild(section);
      slide.appendChild(inner);
      swiperWrapper.appendChild(slide);
    });

    if (footer) {
      const slide = document.createElement("div");
      slide.className = "swiper-slide";

      const inner = document.createElement("div");
      inner.className = "slide-inner";

      inner.appendChild(footer);
      slide.appendChild(inner);
      swiperWrapper.appendChild(slide);
    }

    if (main) {
      main.style.display = "none";
    }

    container.classList.add("swiper");
    container.prepend(swiperWrapper);

    let wheelBusy = false;

    const swiper = new Swiper(container, {
      direction: "vertical",
      slidesPerView: 1,
      speed: SPEED,
      virtualTranslate: true,

      /*
       * Swiper 기본 터치 대신
       * 아래에서 직접 드래그를 처리함
       */
      allowTouchMove: false,
      simulateTouch: false,

      mousewheel: false,

      keyboard: {
        enabled: true,
      },

      on: {
        init: function () {
          setPositions(this, false);
        },

        slideChangeTransitionStart: function () {
          setPositions(this, true);
        },
      },
    });

    /*
     * 헤더 색상 변경
     */
    const header = document.querySelector(".header");

    function updateHeaderTheme() {
      const activeSlide =
        swiper.slides[swiper.activeIndex];

      const themeElement = activeSlide?.querySelector(
        ".is-dark, .is-light",
      );

      if (!header) return;

      header.classList.remove("is-dark", "is-light");

      if (themeElement?.classList.contains("is-dark")) {
        header.classList.add("is-dark");
      }

      if (themeElement?.classList.contains("is-light")) {
        header.classList.add("is-light");
      }
    }

    updateHeaderTheme();
    swiper.on("slideChange", updateHeaderTheme);

    /*
     * 드래그 상태
     */
    let suppressNextClick = false;

    const gesture = {
      active: false,
      dragging: false,
      locked: false,

      pointerId: null,

      startY: 0,
      currentY: 0,

      lastY: 0,
      lastTime: 0,
      velocityY: 0,

      direction: null,
      targetSlide: null,
    };

    function getPointerY(e) {
      return e.clientY;
    }

    function resetGesture() {
      gesture.active = false;
      gesture.dragging = false;
      gesture.pointerId = null;

      gesture.startY = 0;
      gesture.currentY = 0;

      gesture.lastY = 0;
      gesture.lastTime = 0;
      gesture.velocityY = 0;

      gesture.direction = null;
      gesture.targetSlide = null;

      container.classList.remove("is-dragging");
    }

    function lockGesture(duration = INPUT_LOCK_TIME) {
      gesture.locked = true;

      setTimeout(function () {
        gesture.locked = false;
      }, duration);
    }

    function animateToCurrentPosition() {
      currentTransitionSpeed = SPEED;
      setPositions(swiper, true);
      lockGesture(INPUT_LOCK_TIME);
    }

    /*
     * 링크와 이미지의 브라우저 기본 드래그 방지
     */
    container.addEventListener(
      "dragstart",
      function (e) {
        e.preventDefault();
      },
    );

    /*
     * 실제 슬라이드 드래그 후 발생하는
     * 링크 클릭만 차단
     */
    container.addEventListener(
      "click",
      function (e) {
        if (!suppressNextClick) return;

        e.preventDefault();
        e.stopPropagation();

        suppressNextClick = false;
      },
      true,
    );

    container.addEventListener(
      "pointerdown",
      function (e) {
        const target =
          e.target instanceof Element ? e.target : null;

        const nestedSwiper =
          target?.closest(".swiper");

        /*
         * 내부에 별도의 Swiper가 있으면
         * 해당 Swiper의 동작을 방해하지 않음
         */
        if (
          nestedSwiper &&
          nestedSwiper !== container
        ) {
          return;
        }

        /*
         * 마우스 왼쪽 버튼만 허용
         */
        if (
          e.pointerType === "mouse" &&
          e.button !== 0
        ) {
          return;
        }

        if (gesture.locked || wheelBusy) {
          return;
        }

        suppressNextClick = false;

        const pointerY = getPointerY(e);
        const now = performance.now();

        gesture.active = true;
        gesture.dragging = false;
        gesture.pointerId = e.pointerId;

        gesture.startY = pointerY;
        gesture.currentY = pointerY;

        gesture.lastY = pointerY;
        gesture.lastTime = now;
        gesture.velocityY = 0;

        gesture.direction = null;
        gesture.targetSlide = null;

        /*
         * 링크 클릭을 유지하기 위해
         * 여기서는 아직 pointer capture를 하지 않음
         */
      },
    );

    container.addEventListener(
      "pointermove",
      function (e) {
        if (
          !gesture.active ||
          e.pointerId !== gesture.pointerId
        ) {
          return;
        }

        const pointerY = getPointerY(e);
        const now = performance.now();
        const elapsed = now - gesture.lastTime;

        gesture.currentY = pointerY;

        /*
         * 현재 손가락 이동 속도 계산
         */
        if (elapsed > 0) {
          const instantVelocity =
            (pointerY - gesture.lastY) / elapsed;

          /*
           * 속도값이 너무 튀지 않도록 보정
           */
          gesture.velocityY =
            gesture.velocityY * 0.25 +
            instantVelocity * 0.75;
        }

        gesture.lastY = pointerY;
        gesture.lastTime = now;

        const H = swiper.height;
        const currentIndex = swiper.activeIndex;
        const deltaY =
          gesture.currentY - gesture.startY;
        const distance = Math.abs(deltaY);

        /*
         * 작은 움직임은 링크 클릭으로 처리
         */
        if (
          !gesture.dragging &&
          distance < DRAG_START_DISTANCE
        ) {
          return;
        }

        /*
         * 실제 드래그 시작
         */
        if (!gesture.dragging) {
          gesture.dragging = true;
          container.classList.add("is-dragging");

          try {
            container.setPointerCapture(e.pointerId);
          } catch (error) {
            // 일부 브라우저의 포인터 캡처 오류 무시
          }
        }

        e.preventDefault();

        /*
         * 위로 드래그
         */
        if (deltaY < 0) {
          const nextIndex = currentIndex + 1;

          /*
           * 이전에 아래 방향으로 드래그했다면
           * 현재 슬라이드를 원위치
           */
          if (
            gesture.direction === "prev" &&
            gesture.targetSlide
          ) {
            gesture.targetSlide.style.transition = "none";
            gesture.targetSlide.style.transform =
              "translate3d(0, 0, 0)";
          }

          if (nextIndex >= swiper.slides.length) {
            gesture.direction = null;
            gesture.targetSlide = null;
            return;
          }

          const nextSlide =
            swiper.slides[nextIndex];

          const dragY = Math.max(0, H + deltaY);

          gesture.direction = "next";
          gesture.targetSlide = nextSlide;

          nextSlide.style.transition = "none";
          nextSlide.style.transform =
            "translate3d(0, " + dragY + "px, 0)";

          return;
        }

        /*
         * 아래로 드래그
         */
        if (deltaY > 0) {
          const previousIndex = currentIndex - 1;

          /*
           * 이전에 위 방향으로 드래그했다면
           * 다음 슬라이드를 다시 화면 아래로 이동
           */
          if (
            gesture.direction === "next" &&
            gesture.targetSlide
          ) {
            gesture.targetSlide.style.transition = "none";
            gesture.targetSlide.style.transform =
              "translate3d(0, " + H + "px, 0)";
          }

          if (previousIndex < 0) {
            gesture.direction = null;
            gesture.targetSlide = null;
            return;
          }

          const currentSlide =
            swiper.slides[currentIndex];

          const dragY = Math.min(H, deltaY);

          gesture.direction = "prev";
          gesture.targetSlide = currentSlide;

          currentSlide.style.transition = "none";
          currentSlide.style.transform =
            "translate3d(0, " + dragY + "px, 0)";
        }
      },
      {
        passive: false,
      },
    );

    function finishDrag(e) {
      if (
        !gesture.active ||
        e.pointerId !== gesture.pointerId
      ) {
        return;
      }

      const H = swiper.height;
      const deltaY =
        gesture.currentY - gesture.startY;

      const draggedRatio = Math.abs(deltaY) / H;
      const direction = gesture.direction;
      const wasDragging = gesture.dragging;

      /*
       * resetGesture 전에 속도값 저장
       */
      const swipeVelocity =
        Math.abs(gesture.velocityY);

      const timeSinceLastMove =
        performance.now() - gesture.lastTime;

      const isFastFlick =
        timeSinceLastMove < 140 &&
        swipeVelocity >= FLICK_VELOCITY;

      const shouldChange =
        draggedRatio >= DRAG_THRESHOLD ||
        isFastFlick;

      if (
        container.hasPointerCapture &&
        container.hasPointerCapture(e.pointerId)
      ) {
        container.releasePointerCapture(e.pointerId);
      }

      /*
       * 실제 드래그였다면 직후 링크 클릭 차단
       */
      if (wasDragging) {
        suppressNextClick = true;

        setTimeout(function () {
          suppressNextClick = false;
        }, 0);
      }

      resetGesture();

      if (!wasDragging || !direction) {
        return;
      }

      /*
       * 50% 이상 드래그하거나
       * 빠르게 플릭하면 슬라이드 전환
       */
      if (shouldChange) {
        if (isFastFlick) {
          /*
           * 빠르게 스와이프할수록
           * 애니메이션 시간이 짧아짐
           */
          currentTransitionSpeed = Math.max(
            MIN_SWIPE_SPEED,
            Math.min(
              MAX_SWIPE_SPEED,
              700 / Math.max(swipeVelocity, 0.1),
            ),
          );
        } else {
          currentTransitionSpeed = SPEED;
        }

        /*
         * 애니메이션 완료 전에도
         * 다음 스와이프 입력 허용
         */
        lockGesture(INPUT_LOCK_TIME);

        if (direction === "next") {
          swiper.slideNext(currentTransitionSpeed);
        } else {
          swiper.slidePrev(currentTransitionSpeed);
        }

        return;
      }

      /*
       * 기준 미달이면 원위치
       */
      animateToCurrentPosition();
    }

    container.addEventListener(
      "pointerup",
      finishDrag,
    );

    container.addEventListener(
      "pointercancel",
      function (e) {
        if (
          !gesture.active ||
          e.pointerId !== gesture.pointerId
        ) {
          return;
        }

        if (
          container.hasPointerCapture &&
          container.hasPointerCapture(e.pointerId)
        ) {
          container.releasePointerCapture(e.pointerId);
        }

        resetGesture();
        animateToCurrentPosition();
      },
    );

    /*
     * 마우스 휠
     */
    container.addEventListener(
      "wheel",
      function (e) {
        const target =
          e.target instanceof Element ? e.target : null;

        const nestedSwiper =
          target?.closest(".swiper");

        if (
          nestedSwiper &&
          nestedSwiper !== container
        ) {
          return;
        }

        e.preventDefault();

        if (
          wheelBusy ||
          gesture.active ||
          gesture.locked
        ) {
          return;
        }

        wheelBusy = true;
        currentTransitionSpeed = SPEED;

        if (e.deltaY > 0) {
          swiper.slideNext(SPEED);
        } else if (e.deltaY < 0) {
          swiper.slidePrev(SPEED);
        }

        /*
        * PC 휠은 애니메이션이 끝날 때까지
        * 다음 wheel 이벤트를 차단
        */
        setTimeout(function () {
          wheelBusy = false;
        }, SPEED + 150);
      },
      {
        passive: false,
      },
    );

    /*
     * 화면 크기 변경
     */
    window.addEventListener(
      "resize",
      function () {
        swiper.update();

        currentTransitionSpeed = SPEED;
        setPositions(swiper, false);
      },
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      setup,
    );
  } else {
    setup();
  }
})();